<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Electronic Statements</div>
      </div>
      <div class="card-content">
        <div class="row">
          <!-- div class="col-xs-6">
            <el-select
              class="select-default"
              v-model="limits.period"
              placeholder="Per page"
              @change="updateTable($event)">
              <el-option
                class="select-default"
                v-for="item in limits.periods"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div -->
          <!-- div class="col-xs-6">
            <div class="pull-right">
              <label>
                <input type="search" class="form-control input-sm" placeholder="Search transactions" v-model="searchQuery" aria-controls="datatables">
              </label>
            </div>
            <div class="pull-right" style="padding-right: 1em;">
              <div>
                <strong>Total:</strong>
                <span class="totals-value">&nbsp;{{ (Math.round(parseFloat(this.data.totals.amount) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
              </div>
              <div>
                <strong>Transactions:</strong>
                <span class="totals-value">&nbsp;{{ this.data.totals.entries.toLocaleString('en-US') }}</span>
              </div>
            </div>
          </div -->
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table class="table-striped"
                      :data="queriedData"
                      border
                      style="width: 100%">
              <el-table-column v-for="column in tableColumns"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :width="column.width"
                              :fixed="column.fixed"
                              :show-overflow-tooltip="true"
                              :prop="column.prop"
                              :label="column.label"
                              :formatter="column.formatter">
              </el-table-column>
            </el-table>
          </div>
          <!-- div class="col-sm-6 pagination-info">
            <p class="category">Showing {{this.data.from === null ? 0 : this.data.from}} to {{this.data.to === null ? 0 : this.data.to}} of {{this.data.total}} entries</p>
          </div>
          <div class="col-sm-6">
            <el-pagination class="pull-right" layout="prev, pager, next" :page-size="this.data.per_page" :total="this.data.total" @current-change="updateLimit($event)"></el-pagination>
          </div -->
          <div class="row">
            <div class="col-md-12">
              <button type="button" @click="redirectToCSV" class="btn btn-fill btn-info">Export CSV</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn} from 'element-ui'

  Vue.use(Table)
  Vue.use(TableColumn)
  // Vue.use(Select)
  // Vue.use(Option)
  export default{
    computed: {
      queriedData () {
        return this.data.data
      }
    },
    data () {
      return {
        tableColumns: [
          {
            prop: 'GroupName',
            label: 'Group',
            width: 100
          },
          {
            prop: 'TrustName',
            label: 'Trust Name',
            width: 300
          },
          {
            prop: 'FirstName',
            label: 'First Name',
            width: 200
          },
          {
            prop: 'LastName',
            label: 'Last Name',
            width: 200
          },
          {
            prop: 'Email',
            label: 'Email Address'
          },
          {
            prop: 'LastStatementDate',
            label: 'Last Statement Date'
          }
        ],
        // give some initial values before a request is made
        data: {
          data: []
        }
      }
    },
    methods: {
      getReportData: function () {
        if (this.$store.state.managerData.GroupId === 0) {
          var url = '/reports/emailStatements'

          this.$http.get(url)
          .then(response => {
            this.data.data = response.data
          })
        }
      },
      redirectToCSV () {
        window.location.href = this.$http.defaults.baseURL + '/reports/emailStatements.csv'
      }
    },
    created () {
    },
    mounted () {
      this.getReportData()
    }
  }
</script>
<style>

.el-table .cell {
  word-break: normal;
  overflow-wrap: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Reports/ElectronicStatements.vue